import { format, parseISO } from 'date-fns';
import { da } from 'date-fns/locale';
import { CaseworkerAbsenceModel } from '../../../../api-service/clients';
import { formatPeriod, today, toStartOfDay } from '../../../../utilities/date-helper';

// The BFF sends a date-only value as midnight with the server's offset; the calendar day must not shift in the browser.
export function absenceDay(value: Date | string): Date {
  return toStartOfDay(typeof value === 'string' ? parseISO(value.slice(0, 10)) : value);
}

export function isActiveOrPlanned(absence: CaseworkerAbsenceModel): boolean {
  return !absence.endDate || absenceDay(absence.endDate) >= today();
}

export function formatAbsencePeriod(absence: CaseworkerAbsenceModel): string {
  if (!absence.endDate) {
    return `Fra ${format(absenceDay(absence.startDate), 'd. MMMM', { locale: da })}, ingen slutdato`;
  }
  return formatPeriod(absenceDay(absence.startDate), absenceDay(absence.endDate));
}
